import * as THREE from 'three'
import gsap from 'gsap'

import OffscreenArrow from './OffscreenArrow.js'

export default class DepositIndicator
{
    constructor(_options)
    {
        this.deposit = _options.deposit
        this.camera = _options.camera
        this.dismissed = false
        this.opacity = 1
        this.container = new THREE.Group()
        this.container.position.set(this.deposit.x, this.deposit.y, 3.1)
        this.pickaxe = this.factoryPickaxe(_options.factory)
        this.ore = null
        if(['ironOre', 'copperOre', 'coal'].includes(this.deposit.resource))
        {
            this.pickaxe.position.x = -0.55
            this.ore = _options.factory.createItem(this.deposit.resource, 2.1)
            this.ore.position.set(0.65, 0, 0.15)
            this.container.add(this.ore)
        }
        this.container.add(this.pickaxe)
        this.prepareFadeMaterials()
        this.offscreenArrow = new OffscreenArrow({ camera: this.camera, position: new THREE.Vector3(this.deposit.x, this.deposit.y, 1.5) })
    }

    factoryPickaxe(_factory)
    {
        const pickaxe = _factory.createTool(false)
        pickaxe.visible = true
        pickaxe.position.set(0, 0, 0)
        pickaxe.rotation.set(0.35, Math.PI - 0.45, Math.PI * 0.5 - 0.6)
        pickaxe.scale.setScalar(1.7)
        return pickaxe
    }

    prepareFadeMaterials()
    {
        this.materials = []
        this.container.traverse((_child) =>
        {
            if(!_child.isMesh)
                return
            _child.material = _child.material.clone()
            _child.material.transparent = true
            this.materials.push({
                material: _child.material,
                opacity: _child.material.uniforms?.opacity?.value ?? _child.material.opacity
            })
        })
    }

    update(_elapsed)
    {
        if(this.dismissed)
            return
        const bob = Math.sin(_elapsed * 0.004) * 0.22
        this.pickaxe.position.z = bob
        this.pickaxe.rotation.z = Math.PI * 0.5 - 0.6 + Math.sin(_elapsed * 0.002) * 0.12
        if(this.ore)
        {
            this.ore.position.z = 0.15 + bob
            this.ore.rotation.z = Math.sin(_elapsed * 0.002) * 0.08
        }
        this.offscreenArrow.update()
    }

    dismiss()
    {
        if(this.dismissed)
            return
        this.dismissed = true
        this.offscreenArrow.remove()
        gsap.to(this, {
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            onUpdate: () => this.setOpacity(),
            onComplete: () => this.container.visible = false
        })
    }

    setOpacity()
    {
        for(const { material, opacity } of this.materials)
        {
            if(material.uniforms?.opacity)
                material.uniforms.opacity.value = opacity * this.opacity
            else
                material.opacity = opacity * this.opacity
        }
    }
}
